import React from "react";
import { Grid } from "Components/Base/Layout/Grid";
import { Box } from "Components/Base/Layout/Box";
import SearchField from "Components/Fragment/SearchField";
import FormControlSelect from "Components/Fragment/Inputs/FormControlSelect";
import {
  STYLE_GRID_CONTAINER,
  STYLE_SEARCH_FIELD,
  STYLE_CONTROLS_BOX,
  STYLE_SELECT,
} from "domains/learningCatalogue/styles";
import { FilterControls } from "domains/learningCatalogue/components/Toolbar";
import { getViewOptions } from "domains/learningCatalogue/utils/toolbarUtils";
import TotalProgressSection from "./components/TotalProgressSection";
import DrawerFilters from "./components/DrawerFilters";
import * as CONSTANTS from "../../constants";
import { useFilter } from "./context";
import { useMyLearning } from "../../context";

const PageFilter = ({ languageContext }) => {
  const {
    state,
    setFilterStatus,
    setSortBy,
    setSearchText,
    onSearch,
    hitCount,
    showHitCount,
    toggleDrawer,
  } = useFilter();

  const { listView, setListView } = useMyLearning();

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleSearchClear = () => {
    setSearchText("");
    onSearch("");
  };

  const handleSearchSubmit = () => {
    onSearch(state.searchText);
  };

  const handleViewChange = (view) => {
    setListView(view === "list");
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={STYLE_GRID_CONTAINER}
      >
        <Grid item xs={12}>
          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            flexWrap="wrap"
            gap={2}
            alignItems={{ xs: "stretch", sm: "center" }}
            justifyContent={{ xs: "stretch", sm: "space-between" }}
          >
            <SearchField
              value={state.searchText}
              ariaLabel={languageContext("search")}
              placeholder={languageContext("search")}
              searchLabel={languageContext("search")}
              clearLabel={languageContext("clearSearch")}
              onChange={handleSearchChange}
              onClear={handleSearchClear}
              onSearch={handleSearchSubmit}
              onBlur={handleSearchSubmit}
              searchMode="onSubmit"
              sx={STYLE_SEARCH_FIELD}
            />

            <Box
              display="flex"
              alignItems="center"
              gap={1}
              flexWrap="wrap"
              sx={STYLE_CONTROLS_BOX}
            >
              <FormControlSelect
                className="filter-sort-select"
                name={languageContext("status")}
                options={CONSTANTS.SORT_OPTIONS_STATUS}
                value={state?.status ? state.status.toLowerCase() : ""}
                onChange={setFilterStatus}
                languageContext={languageContext}
                displayLabel={false}
                sx={STYLE_SELECT}
                translateOptions={true}
              />
              <FormControlSelect
                className="filter-sort-select"
                name={languageContext("sort")}
                options={CONSTANTS.SORT_OPTIONS_ORDER}
                value={state?.sortBy ? state.sortBy.toLowerCase() : ""}
                onChange={setSortBy}
                languageContext={languageContext}
                displayLabel={false}
                sx={STYLE_SELECT}
                translateOptions={true}
              />
              <FormControlSelect
                className="filter-sort-select"
                name={languageContext("view")}
                options={getViewOptions(languageContext)}
                value={listView ? "list" : "card"}
                onChange={handleViewChange}
                sx={STYLE_SELECT}
                displayLabel={false}
              />
              <FilterControls
                languageContext={languageContext}
                onFilter={toggleDrawer}
                isFilterOpen={state.drawerOpen}
              />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Box display="flex" justifyContent="flex-end">
            <TotalProgressSection languageContext={languageContext} scale={1} />
          </Box>
        </Grid>
      </Grid>
      <DrawerFilters
        hitCount={hitCount}
        showHitCount={showHitCount}
        languageContext={languageContext}
      />
    </>
  );
};

export default PageFilter;
